import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutHero from '../components/about/AboutHero';
import AboutStats from '../components/about/AboutStats';
import WhyChooseUs from '../components/about/WhyChooseUs';
import OurServices from '../components/about/OurServices';
import Achievements from '../components/about/Achievements';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <AboutHero />
      <AboutStats />
      <WhyChooseUs />
      <OurServices />
      <Achievements />
      <Footer />
    </div>
  );
};

export default About;
